import { call, put, takeEvery } from "redux-saga/effects";
import {
  travelPremiumsSuccess,
  travelPremiumsError,
} from "./actions";
import { TRAVEL_PREMIUMS } from "./actionTypes";
import { postTravelPremiums } from "../../resources/helper/travelPremiums";

function* travelPremiums({ payload: { body } }) {
  try {
    const response = yield call(postTravelPremiums, body);
    yield put(travelPremiumsSuccess(response));
  } catch (error) {
    yield put(travelPremiumsError(error));
  }
}

function* travelPremiumsSaga() {
  yield takeEvery(TRAVEL_PREMIUMS, travelPremiums);
}

export default travelPremiumsSaga;
